import { EventEmitter } from 'events'

export const EVENT_UNAUTHORIZED = 'event-unauthorized'
export const EVENT_FORBIDDEN = 'event-forbidden'
export const EVENT_NO_COMPANY = 'event-no-company'
export const EVENT_NOT_FOUND = 'not-found'

const eventManager = new EventEmitter()
export default eventManager
